import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  subdomain: '',
  mode: 'list', // 'list', 'map'
};

const slice = createSlice({
  name: 'checkout',
  initialState: reHydrateStore('checkout') || initialState,
  reducers: {
    setCheckout: (state, { payload }) => ({ ...payload }),
    setSubdomain: (state, { payload }) => ({
      ...state,
      subdomain: payload,
    }),
    setBookingMode: (state, { payload }) => ({
      ...state,
      mode: payload,
    }),
    restore: (state, { payload }) => ({
      ...initialState,
      subdomain: state.subdomain,
    }),
  },
});

export const { setCheckout, setSubdomain, setBookingMode, restore } =
  slice.actions;

export default slice.reducer;
